(function () {
  'use strict';

  function track(name, source, extra) {
    if (!/^[a-z][a-z0-9_]{0,63}$/.test(name)) return;
    if (window.Shopify?.designMode || window.Shopify?.theme?.role === 'development') return;
    var values = Object.assign({
      placement: source?.dataset.croPlacement || '',
      product: source?.dataset.croProduct || '',
      variant: source?.dataset.croVariant || '',
      destination: source?.dataset.croDestination || ''
    }, extra || {});
    // Never send message text, contact details or WhatsApp query strings to analytics.
    var properties = {};
    ['placement', 'product', 'variant', 'destination'].forEach(function (key) {
      properties[key] = String(values[key] || '').slice(0, 120);
    });
    var payload = Object.assign({ event: name, cro_event: name }, properties);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, properties);
    }
    if (typeof window.rybbit?.event === 'function') window.rybbit.event(name, properties);
  }

  document.addEventListener('haley:track', function (event) {
    if (event.detail) track(event.detail.event, null, event.detail);
  });

  // Successful add_to_cart comes from the Rybbit Shopify pixel (Customer events), which
  // also sees the native form POSTs on the haley-* product sections. Tracking it here too
  // would double count.

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var tracked = target.closest('[data-cro-event]');
    if (tracked) {
      track(tracked.dataset.croEvent, tracked);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('[data-type="add-to-cart-form"]')) {
      track('add_to_cart_attempt', form, {
        placement: form.dataset.croPlacement || 'product_form',
        product: form.dataset.croProduct || ''
      });
    }
  });
})();
